exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".post-list .card{height:100%}.post-list .card .image img{object-fit:cover}.post-list .card:hover{opacity:.8}.post-list .card .card-content{padding:1rem}.post-list .card .card-content .media{margin-bottom:1rem}.post-list .card .subtitle{overflow:hidden}", ""]);

// exports
